function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from "react";
import * as types from "../utils/types";
import SchemaLayout from "./SchemaLayout";
import { getWidget, getUiOptions, isSelect, optionsList, getDefaultRegistry } from "../utils/";

class StringField extends Component {
  render() {
    const _this$props = this.props,
          schema = _this$props.schema,
          name = _this$props.name,
          uiSchema = _this$props.uiSchema,
          idSchema = _this$props.idSchema,
          formData = _this$props.formData,
          required = _this$props.required,
          disabled = _this$props.disabled,
          readonly = _this$props.readonly,
          autofocus = _this$props.autofocus,
          onChange = _this$props.onChange,
          onBlur = _this$props.onBlur,
          onFocus = _this$props.onFocus,
          _this$props$registry = _this$props.registry,
          registry = _this$props$registry === void 0 ? getDefaultRegistry() : _this$props$registry,
          rawErrors = _this$props.rawErrors;
    const title = schema.title,
          format = schema.format;
    const widgets = registry.widgets,
          formContext = registry.formContext;
    const enumOptions = isSelect(schema) && optionsList(schema);
    const defaultWidget = format || (enumOptions ? "select" : "text");

    const _getUiOptions = getUiOptions(uiSchema),
          language = _getUiOptions.language,
          _getUiOptions$widget = _getUiOptions.widget,
          widget = _getUiOptions$widget === void 0 ? defaultWidget : _getUiOptions$widget,
          _getUiOptions$placeho = _getUiOptions.placeholder,
          placeholder = _getUiOptions$placeho === void 0 ? "" : _getUiOptions$placeho,
          options = _objectWithoutPropertiesLoose(_getUiOptions, ["language", "widget", "placeholder"]);

    const Widget = getWidget(schema, widget, widgets);
    return React.createElement(SchemaLayout, this.props, React.createElement(Widget, {
      options: _extends({}, options, {
        enumOptions
      }),
      language: language,
      schema: schema,
      id: idSchema && idSchema.$id,
      label: title === undefined ? name : title,
      value: formData,
      onChange: onChange,
      onBlur: onBlur,
      onFocus: onFocus,
      required: required,
      disabled: disabled,
      readonly: readonly,
      formContext: formContext,
      autofocus: autofocus,
      registry: registry,
      placeholder: placeholder,
      rawErrors: rawErrors
    }));
  }

}

_defineProperty(StringField, "defaultProps", {
  uiSchema: {},
  disabled: false,
  readonly: false,
  autofocus: false
});

StringField.propTypes = process.env.NODE_ENV !== "production" ? types.fieldProps : {};
export default StringField;